export default __webpack_public_path__ + "static/media/girl2.fd1ce4be.jpg";